import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Pillow } from '@/components/Pillow/Pillow'
import type * as SelectPrimitive from '@radix-ui/react-select'
import { Select } from 'ui/src/components/Select/Select'
import { xStack } from 'ui/src/patterns/stack'
import { type ProductOption } from '../ProductPurchaseForm'
import homePillow from './pillow-home.png'
import { placeholderPillow } from './ProductSelector.css'

type Props = {
  productOptions: Array<ProductOption>
  defaultValue?: ProductOption['value']
} & Omit<SelectPrimitive.SelectProps, 'children'>

export const ProductSelector = ({ productOptions, ...delegated }: Props) => {
  const { t } = useTranslation('purchase-form')

  return (
    <Select.Root {...delegated}>
      <Select.Trigger fullWidth={true}>
        <div className={xStack({ gap: 'xs', alignItems: 'center' })}>
          <Pillow className={placeholderPillow} size="xsmall" src={homePillow.src} imagePriority={true} />
          <Select.Value placeholder={t('FIELD_INSURANCE_SELECTOR_PLACEHOLDER')} />
        </div>
      </Select.Trigger>

      <Select.Content position="popper" sideOffset={4}>
        <Select.Options>
          {productOptions.map((option) => (
            <Fragment key={option.value}>
              <Select.Item value={option.value}>
                <Select.ItemText asChild={true}>
                  <div className={xStack({ gap: 'xs', alignItems: 'center' })}>
                    <Pillow size="xsmall" {...option.img} />
                    <span>{option.name}</span>
                  </div>
                </Select.ItemText>

                <Select.ItemIndicator />
              </Select.Item>
            </Fragment>
          ))}
        </Select.Options>
      </Select.Content>
    </Select.Root>
  )
}
